// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_nr-0";
export var animationContainer = "_nr-1";
export var itemPrice = "_nr-a";
export var itemizedContent = "_nr-9";
export var itemizedHeader = "_nr-7";
export var itemizedRow = "_nr-8";
export var itemizedSection = "_nr-6";
export var modalContent = "_nr-2";
export var orderName = "_nr-3";
export var refundOption = "_nr-4";
export var refundOptionsContainer = "_nr-5";
export var shippingLabel = "_nr-b";
export var totalRow = "_nr-c";